import api from "./axios";

export const loginApi = (data) => api.post("/auth/login", data);
export const getProfileApi = () => api.get("/auth/profile");
export const logoutApi = () => api.get("/auth/logout");
